import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export const removeMember = async (payload: {
  companyId: number
  userId: number
}) => {
  const { data } = await companiesApi.delete(
    apiRoutes.updateUserByCompany(payload.companyId, payload.userId),
  )

  return data as unknown
}
